import colors from 'style-utils/colors';

const borderRadius = '10px';
const boxShadow = `0 4px 20px 0 ${colors.modalBoxShadow}`;
const bottom = '';
const transform = '';

export default {
  modal: {
    header: {
      mobile: {
        padding: '0 50px 0 20px',
      },
      tablet: {
        padding: '0 50px 0 20px',
      },
      desktop: {
        padding: '0 60px 0 24px',
      },
    },
    content: {
      mobile: {
        top: '50px',
        // Defaults 'top' if bottom is falsy.
        bottom,
        width: '95%',
        padding: '50px 0 0',
        borderRadius,
        boxShadow,
        transform,
      },
      tablet: {
        top: '100px',
        bottom,
        width: '70%',
        padding: '50px 0 0',
        borderRadius,
        boxShadow,
        transform,
      },
      desktop: {
        top: '100px',
        bottom,
        width: '50%',
        padding: '60px 0 0',
        borderRadius,
        boxShadow,
        transform,
        minWidth: '',
      },
    },
    scrollableWrapper: {
      mobile: {
        maxHeight: '85vh',
      },
      tablet: {
        maxHeight: '85vh',
      },
      desktop: {
        maxHeight: '85vh',
      },
    },
    overlay: {
      background: colors.darkOverlayBackground,
    },
  },
};
